export default __webpack_public_path__ + "static/media/jupiter.69c8f961.jpg";